import escape from '@/common/helpers/escape';
import stringToXML from '@/common/helpers/string-to-xml';

const getFlattenXMLDocument = (doc) => {
    const nodes = doc.evaluate('//*[not(descendant::*)]', doc, null, XPathResult.ANY_TYPE, null);

    let item = nodes.iterateNext();
    const results = [item];

    while (item) {
        item = nodes.iterateNext();
        if (item) {
            results.push(item);
        }
    }
    return results.reduce((memo, node) => {
        const name = escape(node.nodeName);
        const value = escape(node.textContent);
        const newLines = (name + value).length > 16 ? '\r\n' : '';
        return [
            ...memo,
            `<${name}>${newLines}${value}${newLines}</${name}>`,
        ];
    }, []);
};

const serializeXMLDocument = doc => new XMLSerializer().serializeToString(doc);

function formatXml(xml) {
    const PADDING = ' '.repeat(2); // set desired indent size here
    const reg = /(>)(<)(\/*)/g;
    let pad = 0;

    xml = xml.replace(reg, '$1\r\n$2$3');

    return xml.split('\r\n').map((node) => {
        let indent = 0;
        if (node.match(/.+<\/\w[^>]*>$/)) {
            indent = 0;
        } else if (node.match(/^<\/\w/) && pad > 0) {
            pad -= 1;
        } else if (node.match(/^<\w[^>]*[^/]>.*$/)) {
            indent = 1;
        } else {
            indent = 0;
        }

        pad += indent;

        return PADDING.repeat(pad - indent) + node;
    }).join('\r\n');
}

export default function ({value, flatten}) {
    const XMLData = flatten
        ? getFlattenXMLDocument(stringToXML(value)).join('\r\n\r\n')
        : serializeXMLDocument(stringToXML(value));

    return formatXml(XMLData);
}
